module.exports = __webpack_public_path__ + "media/assets/images/tenant-portal-tips/warm-water3-3999613544513253b4ebb9e2c050fd00.jpg";